var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"the-crm"}},[_c('the-header'),_c('the-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }